import { render, staticRenderFns } from "./VueVideo.vue?vue&type=template&id=282394a8&"
import script from "./VueVideo.vue?vue&type=script&lang=js&"
export * from "./VueVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports